<template>
  <van-nav-bar
    title="已报名课程"
    left-text="返回"
    left-arrow
    @click-left="$router.back()"
    fixed
    placeholder
  />

  <!-- 加载中 -->
  <div v-if="loading" class="loading-wrap">
    <van-loading type="spinner" color="#52C1B2" />
  </div>

  <div v-else class="detail-page">
    <!-- 核心信息卡片 -->
    <div class="info-card">
      <div class="card-header">
        <h1 class="course-title">{{ detail.title || detail.course_title }}</h1>
        <!-- <van-tag
          :color="getTypeConfig(detail.course_type).bg"
          :text-color="getTypeConfig(detail.course_type).text"
          size="medium"
        >
          {{ getTypeConfig(detail.course_type).textLabel }}
        </van-tag> -->
      </div>

      <div v-if="detail.course_type === 1 && detail.cost" class="price-row">
        <van-icon name="gold-coin-o" class="price-icon" />
        <span class="price-label">材料费</span>
        <span class="price-num">¥{{ detail.cost }}</span>
        <span class="price-unit"
          >元<template v-if="detail.cost != '0.00'"> </template
        ></span>
      </div>

      <!-- 基础信息列表 -->
      <div class="meta-list">
        <div v-if="detail.enrollment_title" class="meta-item">
          <van-icon name="notes-o" />
          <span class="meta-label">招生批次</span>
          <span class="meta-value">{{ detail.enrollment_title }}</span>
        </div>
        <div v-if="detail.service_class_name" class="meta-item">
          <van-icon name="friends-o" />
          <span class="meta-label">班级</span>
          <span class="meta-value">{{ detail.service_class_name }}</span>
        </div>
        <div v-if="detail.service_week" class="meta-item">
          <van-icon name="calendar-o" />
          <span class="meta-label">上课时间</span>
          <span class="meta-value">{{ detail.service_week }}</span>
        </div>
        <div v-if="detail.service_time" class="meta-item">
          <van-icon name="clock-o" />
          <span class="meta-label">上课时段</span>
          <span class="meta-value">{{ detail.service_time }}</span>
        </div>
        <div v-if="detail.location" class="meta-item">
          <van-icon name="location-o" />
          <span class="meta-label">上课地点</span>
          <span class="meta-value">{{ detail.location }}</span>
        </div>
        <div v-if="detail.course_type !== 1 && detail.hour_cost" class="meta-item">
          <van-icon name="gold-coin-o" />
          <span class="meta-label">课时费</span>
          <span class="meta-value">
            <!-- ¥{{ detail.hour_cost }} 元/{{
              detail.class_hour ? detail.class_hour + "课时" : "课时"
            }} -->
            ¥{{ detail.hour_cost }}元{{
              Number(detail.hour_cost) > 0
                ? " /" + (detail.class_hour ? detail.class_hour + "课时" : "课时")
                : ""
            }}
          </span>
        </div>
      </div>
    </div>

    <!-- 课程介绍（富文本） -->
    <div v-if="detail.course_introduction" class="section-card">
      <div class="section-title">
        <van-icon name="records" />
        <span>课程介绍</span>
      </div>
      <div class="rich-text" v-html="detail.course_introduction"></div>
    </div>
  </div>

  <!-- 底部按钮（撤销后隐藏整栏） -->
  <div v-if="!loading && !isCanceled" class="bottom-bar">
    <van-button
      type="danger"
      block
      round
      size="large"
      :loading="submitting"
      loading-text="提交中..."
      @click="handleCancelEnrollment"
    >
      取消报名
    </van-button>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { Dialog, Toast } from "vant";
import { useRoute } from "vue-router";
import api from "../service/api";
//  1: { textLabel: "校外机构", bg: "#fff7e6", text: "#ff8800" },

const courseTypeConfig = {
  1: { textLabel: "校内课程", bg: "#fff7e6", text: "#ff8800" },
  2: { textLabel: "校内课程", bg: "#e6fffb", text: "#52C1B2" },
  3: { textLabel: "特色课程", bg: "#f9f0ff", text: "#7232dd" },
};

export default {
  setup() {
    const route = useRoute();
    const loading = ref(true);
    const course_id = ref("");
    const detail = ref({});
    const isCanceled = ref(false);
    // 撤销报名进行中：与请求层去重配套，保证业务回调只跑一遍
    const submitting = ref(false);

    const getTypeConfig = (type) => {
      // console.log(cost);
      if (type === 1) {
        return { textLabel: "校外专业导师课", bg: "#fff7e6", text: "#ff8800" };
      }
      return (
        courseTypeConfig[type] || { textLabel: "校内课", bg: "#f5f5f5", text: "#666" }
      );
    };

    const onLoad = (silent = false) => {
      loading.value = true;
      api
        .getEnrollmentById({
          enrollment_schedule_id: course_id.value,
          student_id: sessionStorage.getItem("childId"),
        })
        .then((res) => {
          if (res.data.code === 1001) {
            detail.value = res.data.result;
          } else {
            if (!silent) Toast.fail(res.data.message || "获取数据失败");
          }
        })
        .catch(() => {
          // 撤销后刷新失败时静默（该排课可能已不再返回），保留原展示
          if (!silent) Toast.fail("网络异常，请稍后重试");
        })
        .finally(() => {
          loading.value = false;
        });
    };

    onMounted(() => {
      course_id.value = route.query.enrollment_schedule_id;
      if (!course_id.value) {
        Toast.fail("缺少课程ID");
        loading.value = false;
        return;
      }
      onLoad();
    });

    // 撤销报名（二次确认）
    const handleCancelEnrollment = () => {
      if (submitting.value) return;
      Dialog.confirm({
        title: "撤销报名",
        message: "确定要撤销该课程的报名吗？",
      })
        .then(() => {
          submitting.value = true;
          Toast.loading({ message: "提交中...", forbidClick: true });
          api
            .cancelStudentEnrollment({
              service_class_student_id: detail.value.service_class_student_id,
            })
            .then((res) => {
              submitting.value = false;
              if (res.data.code === 1001) {
                Toast.success("已撤销报名");
                isCanceled.value = true; // 隐藏撤销按钮
                onLoad(true); // 重新刷新详情（失败静默）
              } else {
                Toast.fail(res.data.message || "撤销失败");
              }
            })
            .catch(() => {
              submitting.value = false;
              Toast.fail("网络异常");
            });
        })
        .catch(() => {
          // 用户取消，不处理
        });
    };

    return {
      loading,
      detail,
      isCanceled,
      submitting,
      handleCancelEnrollment,
      getTypeConfig,
    };
  },
};
</script>

<style lang="less" scoped>
.loading-wrap {
  display: flex;
  justify-content: center;
  padding-top: 80px;
}

.detail-page {
  padding: 12px;
  background-color: #f7f8fa;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 110px;
}

/* ---- 底部按钮 ---- */
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 16px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

/* ---- 信息卡片 ---- */
.info-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 14px;

    .course-title {
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      flex: 1;
      margin-right: 10px;
      line-height: 1.4;
    }
  }

  .price-row {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 10px 12px;
    background: #fff9f0;
    border-radius: 8px;
    margin-bottom: 14px;

    .price-icon {
      color: #ff8800;
      font-size: 17px;
    }
    .price-label {
      font-size: 13px;
      color: #999;
      margin-right: 4px;
    }
    .price-num {
      font-size: 22px;
      font-weight: bold;
      color: #ff4d4f;
    }
    .price-unit {
      font-size: 13px;
      color: #999;
      margin-left: 2px;
    }
  }

  .meta-list {
    .meta-item {
      display: flex;
      align-items: center;
      padding: 7px 0;
      border-bottom: 1px solid #f5f5f5;
      font-size: 14px;

      &:last-child {
        border-bottom: none;
      }

      .van-icon {
        font-size: 16px;
        color: var(--color-primary);
        margin-right: 8px;
        flex-shrink: 0;
      }
      .meta-label {
        color: #999;
        width: 68px;
        flex-shrink: 0;
      }
      .meta-value {
        color: #333;
        flex: 1;
      }
    }
  }
}

/* ---- 内容分区卡片 ---- */
.section-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  overflow: hidden;

  .section-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: bold;
    color: #1a1a1a;
    margin-bottom: 12px;
    padding-left: 4px;
    border-left: 3px solid var(--color-primary);

    .van-icon {
      font-size: 16px;
      color: var(--color-primary);
    }
  }

  .rich-text {
    font-size: 14px;
    color: #333;
    line-height: 1.7;
    word-break: break-all; /* 自动换行 */
    word-wrap: break-word; /* 兼容换行 */
    overflow-wrap: break-word; /* 标准换行 */

    :deep(img) {
      max-width: 100% !important; /* 图片永远不超出屏幕 */
      height: auto !important; /* 高度自适应 */
      display: block; /* 去掉图片底部空白 */
      margin: 8px 0; /* 图片上下间距 */
      border-radius: 6px;
    }

    :deep(p) {
      margin: 0 0 10px !important;
      line-height: 1.7 !important;
    }

    /* 适配所有富文本标签 */
    :deep(div),
    :deep(section),
    :deep(span),
    :deep(h1),
    :deep(h2),
    :deep(h3),
    :deep(h4) {
      max-width: 100% !important;
      box-sizing: border-box !important;
      word-break: break-all !important;
    }
    :deep(table) {
      width: 100% !important;
      display: block !important;
      overflow-x: auto !important;
      border-collapse: collapse;
      margin: 10px 0;
    }

    :deep(td),
    :deep(th) {
      word-break: break-all !important;
      padding: 6px 4px;
      border: 1px solid #eee;
    }
  }
}
</style>
